import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from '@app/env';
import { TokenRedirection } from '../models/token-redirection.model';

@Injectable({
  providedIn: 'root',
})
export class TokenRedirectionService {
  private readonly API = environment.apiProfessor;
  private http = inject(HttpClient);

  public redirect(token: string): Observable<TokenRedirection[]> {
    return this.http
      .get<TokenRedirection[]>(`${this.API}/login`, {
        params: { tipo: 'TOKEN', VALOR: token },
      })
      .pipe(
        tap((response) => {
          sessionStorage.setItem('token', JSON.stringify(response[0]));
        }),
      );
  }
}
